import { API_URL, getAuthHeaders } from './config';

export const systemService = {
    getPublicSettings: async () => {
        const res = await fetch(`${API_URL}/public/settings`);
        if (!res.ok) throw new Error("Failed to fetch public settings");
        return res.json();
    },
    getSettings: async () => {
        const res = await fetch(`${API_URL}/admin/settings`, { headers: getAuthHeaders() });
        if (!res.ok) throw new Error("Failed to fetch settings");
        return res.json();
    },
    updateSettings: async (settings: any) => {
        const res = await fetch(`${API_URL}/admin/settings`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
            body: JSON.stringify(settings)
        });
        if (!res.ok) throw new Error("Failed to update settings");
        return res.json();
    },
    testEmail: async (email: string) => {
        const res = await fetch(`${API_URL}/admin/system/test-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
            body: JSON.stringify({ email })
        });
        if (!res.ok) throw new Error("Failed to send test email");
        return res.json();
    },
    sendContact: async (data: { name: string, email: string, message: string, subject?: string, company?: string, phone?: string, type?: string }) => {
        const res = await fetch(`${API_URL}/public/contact`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to send message");
        return res.json();
    },
    trackInstall: async () => {
        const res = await fetch(`${API_URL}/public/stats/install`, {
            method: 'POST'
        });
        return res.json();
    }
};
